import React, { Dispatch, SetStateAction, useState, useCallback } from 'react';
import debug from 'debug';
import shopifyClient from '../lib/shopifyClient';
import { getShopifyPageByHandle } from 'lib/amplify';
import { CGPage } from 'types/shopify';

const d = debug('pagesContext');

interface IPageContextInterface {
  pages: any[];
  havePages: boolean;
  loadPages: () => void;
  setPages: Dispatch<SetStateAction<any[]>>;
  getPageByHandle: (handle: string) => any | undefined;
  loadPageByHandle: (handle: string, refresh?: boolean) => Promise<CGPage | undefined>;
}

export const pagesContext = React.createContext<IPageContextInterface>({
  pages: [],
  havePages: false,
  loadPages: () => undefined,
  setPages: () => [],
  getPageByHandle: () => undefined,
  loadPageByHandle: () => Promise.resolve(undefined),
});

const { Provider } = pagesContext;

const PageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pages, setPages] = useState<any[]>([]);
  const [havePages, setHavePages] = useState<boolean>(false);

  const loadPages = useCallback(() => {
    d('loading CMS content');
    // @ts-ignore
    const pageQuery = shopifyClient.graphQLClient.query((root) => {
      root.addConnection(
        'pages',
        {
          args: {
            first: 250,
          },
        },
        (page: any) => {
          page.add('title');
          page.add('body');
          page.add('bodySummary');
          page.add('handle');
          page.add('updatedAt');
          // page.add("seo"); TODO - Get the seo content too...
        },
      );
    });
    d('pageQuery', pageQuery);
    // @ts-ignore
    shopifyClient.graphQLClient.send(pageQuery).then((data: any) => {
      d('CMS content loaded', data.model.pages);
      setPages(data.model.pages);
      setHavePages(true);
    });
  }, []);

  const getPageByHandle = useCallback(
    (handle: string): any | undefined => {
      return pages.find((Page) => Page.handle === handle);
    },
    [pages],
  );

  const loadPageByHandle = useCallback((pageHandle: string, refresh: boolean = false) => {
    return getShopifyPageByHandle(pageHandle, refresh);
  }, []);

  return (
    <Provider
      value={{
        pages,
        havePages,
        loadPages,
        setPages,
        loadPageByHandle,
        getPageByHandle,
      }}
    >
      {children}
    </Provider>
  );
};

export default PageProvider;
